import React from 'react'
import { useHistory } from 'react-router-dom'
import { Checkbox, Button } from 'antd'
import { InputNumber } from 'components'
import defaultImg from 'app/assets/images/default.png'
import classNames from 'classnames'
import { getAuthorName } from 'utils'
import { SwaggerDTO1 } from 'services/store'
import { GoodsImg } from '../'
import './index.less'

interface CardProps {
  /**失效 */
  lose?: boolean
  /**购物车信息 */
  data?: SwaggerDTO1.购物车信息1 & { allSalePrice?: number; spuType?: number }
  /**库存信息 */
  skuStocks?: Object
  /**更改数量 */
  numChange?: Function
  /**删除 */
  onDelete?: Function
}
export default function Card({
  lose,
  data,
  skuStocks,
  numChange,
  onDelete,
}: CardProps) {
  const history = useHistory()

  const openDetail = () => {
    // 文创
    if (data?.spuType === 3) {
      history.push(`/detail/booart?spuCode=${data?.spuCode}`)
    }

    // 图书
    if ([1, 4].includes(data?.spuType!)) {
      history.push(`/detail/book?spuCode=${data?.spuCode}`)
    }
  }

  return (
    <div className={classNames('cart-card', lose && 'lose')}>
      <Checkbox
        value={data?.id}
        disabled={lose}
        className="cart-card-check-box"
      />
      <GoodsImg
        src={
          (data?.spuType === 3 ? data?.skuImgUrl : data?.appImgUrl) ||
          defaultImg
        }
        onClick={openDetail}
        ifExpired={data?.shelfStatus}
        ifSoldOut={data?.stockStatus}
      />
      <div className="cart-card-info">
        <p className="cart-card-info-title">
          {data?.spuType === 3 ? data?.skuName : data?.spuName}
        </p>
        {[1, 4].includes(data?.spuType!) && (
          <div>
            <p className="cart-card-info-author">
              作者：{getAuthorName(data?.authorDTOS)}
            </p>
            <p className="cart-card-info-press">出版社：{data?.pressName}</p>
          </div>
        )}
      </div>
      <div className="cart-card-price">
        ¥<span>{data?.salePrice}</span>
      </div>
      <div className="cart-card-input">
        {!lose && (
          <InputNumber
            showTips={false}
            value={data?.num}
            max={skuStocks?.[data?.skuCode || '']?.usableStock}
            onChange={e => numChange?.(e)}
          />
        )}
      </div>
      <div className="cart-card-price" style={{ marginRight: '125px' }}>
        {!lose && (
          <>
            ¥<span>{data?.allSalePrice}</span>
          </>
        )}
      </div>
      <Button
        type="link"
        size="small"
        className="cart-card-button"
        onClick={() => onDelete?.(data)}
      >
        删除
      </Button>
    </div>
  )
}
